import React from 'react'

export const TraceManagerDebuggerLazy = React.lazy(
  () => import('./TraceManagerDebugger'),
)
